import { set } from '@shopworx/services/util/store.helper';

export default ({
  namespaced: true,
  state: {
    previewType: 0,
    previewData: null,
  },
  mutations: {
    setPreviewType: set('previewType'),
    setPreviewData: set('previewData'),
  },
  actions: {
    getElement: async ({ dispatch }, { elementname, query }) => {
      const list = await dispatch(
        'element/getRecords',
        { elementName: elementname, query },
        { root: true },
      );
      if (list) {
        return list;
      }
      return [];
    },
    postElement: async ({ dispatch }, { elementname, payload }) => {
      const result = await dispatch(
        'element/postRecord',
        { elementName: elementname, payload },
        { root: true },
      );
      if (result) {
        console.log(result, 'result');
        return result.id;
      }
      return false;
    },
    deleteElement: async ({ dispatch }, { elementname, id }) => {
      const result = await dispatch(
        'element/deleteRecordById',
        { elementName: elementname, id },
        { root: true },
      );
      if (result) {
        return true;
      }
      return false;
    },
    updateElement: async ({ dispatch }, { elementname, id, payload }) => {
      const result = await dispatch(
        'element/updateRecordById',
        {
          elementName: elementname,
          id,
          payload,
        },
        { root: true },
      );
      if (result) {
        return true;
      }
      return false;
    },
    executeReportFile: async ({ dispatch }, { payload }) => {
      const result = await dispatch(
        'report/executeReportFile',
        {
          payload,
        },
        { root: true },
      );
      if (result) {
        return true;
      }
      return false;
    },
    deleteReportFile: async ({ dispatch }, { query }) => {
      const result = await dispatch(
        'report/deleteReportFile',
        {
          query,
        },
        { root: true },
      );
      if (result) {
        return true;
      }
      return false;
    },
  },
});
